/*! 
 * angular-loading-bar v0.9.0
 * https://chieffancypants.github.io/angular-loading-bar
 * Copyright (c) 2016 Wes Cruver
 * License: MIT
 
!function(){"use strict";angular.module("angular-loading-bar",["cfp.loadingBarInterceptor"]),angular.module("chieffancypants.loadingBar",["cfp.loadingBarInterceptor"]),angular.module("cfp.loadingBarInterceptor",["cfp.loadingBar"]).config(["$httpProvider",function(a){var b=["$q","$cacheFactory","$timeout","$rootScope","$log","cfpLoadingBar",function(b,c,d,e,f,g){function h(){d.cancel(j),g.complete(),l=0,k=0}function i(b){var d,e=c.get("$http"),f=a.defaults;!b.cache&&!f.cache||b.cache===!1||"GET"!==b.method&&"JSONP"!==b.method||(d=angular.isObject(b.cache)?b.cache:angular.isObject(f.cache)?f.cache:e);var g=void 0!==d?void 0!==d.get(b.url):!1;return void 0!==b.cached&&g!==b.cached?b.cached:(b.cached=g,g)}var j,k=0,l=0,m=g.latencyThreshold;return{request:function(a){return a.ignoreLoadingBar||i(a)||(e.$broadcast("cfpLoadingBar:loading",{url:a.url}),0===k&&(j=d(function(){g.start()},m)),k++,g.set(l/k)),a},response:function(a){return a&&a.config?(a.config.ignoreLoadingBar||i(a.config)||(l++,e.$broadcast("cfpLoadingBar:loaded",{url:a.config.url,result:a}),l>=k?h():g.set(l/k)),a):(f.error("Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50"),a)},responseError:function(a){return a&&a.config?(a.config.ignoreLoadingBar||i(a.config)||(l++,e.$broadcast("cfpLoadingBar:loaded",{url:a.config.url,result:a}),l>=k?h():g.set(l/k)),b.reject(a)):(f.error("Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50"),b.reject(a))}}}];a.interceptors.push(b)}]),angular.module("cfp.loadingBar",[]).provider("cfpLoadingBar",function(){this.autoIncrement=!0,this.includeSpinner=!0,this.includeBar=!0,this.latencyThreshold=100,this.startSize=.02,this.parentSelector="body",this.spinnerTemplate='<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>',this.loadingBarTemplate='<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>',this.$get=["$injector","$document","$timeout","$rootScope",function(a,b,c,d){function e(){if(k||(k=a.get("$animate")),c.cancel(m),!r){var e=b[0],g=e.querySelector?e.querySelector(n):b.find(n)[0];g||(g=e.getElementsByTagName("body")[0]);var h=angular.element(g),i=g.lastChild&&angular.element(g.lastChild);d.$broadcast("cfpLoadingBar:started"),r=!0,v&&k.enter(o,h,i),u&&k.enter(q,h,o),f(w)}}function f(a){if(r){var b=100*a+"%";p.css("width",b),s=a,t&&(c.cancel(l),l=c(function(){g()},250))}}function g(){if(!(h()>=1)){var a=0,b=h();a=b>=0&&.25>b?(3*Math.random()+3)/100:b>=.25&&.65>b?3*Math.random()/100:b>=.65&&.9>b?2*Math.random()/100:b>=.9&&.99>b?.005:0;var c=h()+a;f(c)}}function h(){return s}function i(){s=0,r=!1}function j(){k||(k=a.get("$animate")),d.$broadcast("cfpLoadingBar:completed"),f(1),c.cancel(m),m=c(function(){var a=k.leave(o,i);a&&a.then&&a.then(i),k.leave(q)},500)}var k,l,m,n=this.parentSelector,o=angular.element(this.loadingBarTemplate),p=o.find("div").eq(0),q=angular.element(this.spinnerTemplate),r=!1,s=0,t=this.autoIncrement,u=this.includeSpinner,v=this.includeBar,w=this.startSize;return{start:e,set:f,status:h,inc:g,complete:j,autoIncrement:this.autoIncrement,includeSpinner:this.includeSpinner,latencyThreshold:this.latencyThreshold,parentSelector:this.parentSelector,startSize:this.startSize}}]})}();*/




/*! 
 * angular-loading-bar v0.9.0
 * https://chieffancypants.github.io/angular-loading-bar
 * Copyright (c) 2016 Wes Cruver
 * License: MIT
 */
/*
 * angular-loading-bar
 *
 * intercepts XHR requests and creates a loading bar.
 * Based on the excellent nprogress work by rstacruz (more info in readme)
 *
 * (c) 2013 Wes Cruver
 * License: MIT
 */


(function() {

    'use strict';
    
    // Alias the loading bar for various backwards compatibilities since the project has matured:
    angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
    angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);
    
    
    /**
     * loadingBarInterceptor service
     *
     * Registers itself as an Angular interceptor and listens for XHR requests.
     */
    angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
      .config(['$httpProvider', function ($httpProvider) {
    
        var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {
    
          /**
           * The total number of requests made
           */
          var reqsTotal = 0;
    
          /**
           * The number of requests completed (either successfully or not)
           */
          var reqsCompleted = 0;
    
          /**
           * The amount of time spent fetching before showing the loading bar
           */
          var latencyThreshold = cfpLoadingBar.latencyThreshold;
    
          /**
           * $timeout handle for latencyThreshold
           */
          var startTimeout;
    
    
          /**
           * calls cfpLoadingBar.complete() which removes the
           * loading bar from the DOM.
           */
          function setComplete() {
            $timeout.cancel(startTimeout);
            cfpLoadingBar.complete();
            reqsCompleted = 0;
            reqsTotal = 0;
          }
    
          /**
           * Determine if the response has already been cached
           * @param  {Object}  config the config option from the request
           * @return {Boolean} retrns true if cached, otherwise false
           */
          function isCached(config) {
            var cache;
            var defaultCache = $cacheFactory.get('$http');
            var defaults = $httpProvider.defaults;
    
            // Choose the proper cache source. Borrowed from angular: $http service
            if ((config.cache || defaults.cache) && config.cache !== false &&
              (config.method === 'GET' || config.method === 'JSONP')) {
                cache = angular.isObject(config.cache) ? config.cache
                  : angular.isObject(defaults.cache) ? defaults.cache
                  : defaultCache;
            }
    
            var cached = cache !== undefined ?
              cache.get(config.url) !== undefined : false;
    
            if (config.cached !== undefined && cached !== config.cached) {
              return config.cached;
            }
            config.cached = cached;
            return cached;
          }
    
    
          return {
            'request': function(config) {
              // Check to make sure this request hasn't already been cached and that
              // the requester didn't explicitly ask us to ignore this request:
              if (!config.ignoreLoadingBar && !isCached(config)) {
                $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
                if (reqsTotal === 0) {
                  startTimeout = $timeout(function() {
                    cfpLoadingBar.start();
                  }, latencyThreshold);
                }
                reqsTotal++;
                cfpLoadingBar.set(reqsCompleted / reqsTotal);
              }
              return config;
            },
    
            'response': function(response) {
              if (!response || !response.config) {
                $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
                return response;
              }
    
              if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
                reqsCompleted++;
                if (reqsCompleted >= reqsTotal) {
                  $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
                  setComplete();
                } else {
                  cfpLoadingBar.set(reqsCompleted / reqsTotal);
                }
              }
              return response;
            },
    
            'responseError': function(rejection) {
              if (!rejection || !rejection.config) {
                $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
                return $q.reject(rejection);
              }
    
              if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
                reqsCompleted++;
                if (reqsCompleted >= reqsTotal) {
                  $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
                  setComplete();
                } else {
                  cfpLoadingBar.set(reqsCompleted / reqsTotal);
                }
              }
              return $q.reject(rejection);
            }
          };
        }];
    
        $httpProvider.interceptors.push(interceptor);
      }]);
    
    
    /**
     * Loading Bar
     *
     * This service handles adding and removing the actual element in the DOM.
     * Generally, best practices for DOM manipulation is to take place in a
     * directive, but because the element itself is injected in the DOM only upon
     * XHR requests, and it's likely needed on every view, the best option is to
     * use a service.
     */
    angular.module('cfp.loadingBar', [])
      .provider('cfpLoadingBar', function() {
    
        this.autoIncrement = true;
        this.includeSpinner = true;
        this.includeBar = true;
        this.latencyThreshold = 100;
        this.startSize = 0.02;
        this.parentSelector = 'body';
        this.spinnerTemplate = `<div id="loading-bar-spinner"> 
                                <svg width="56px" height="56px" viewBox="0 0 462 462" version="1.1">
                                    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g transform="translate(-859.000000, -203.000000)">
                                            <g id="Group" transform="translate(859.000000, 203.000000)">
                                                <path d="M228,169 C228,201.602712 201.573043,228 169.012122,228 C136.451202,228 110,201.602712 110,169 C110,136.397288 136.451202,110 169.012122,110 C201.573043,110 228,136.397288 228,169" id="Fill-1" fill="#00A8B0"></path>
                                                <path d="M156.03946,268 C135.073036,268 118,285.002766 118,305.947441 C118,326.918396 135.073036,344 156.03946,344 C177.005884,344 194,326.918396 194,305.947441 C194,285.002766 177.005884,268 156.03946,268" id="Fill-3" fill="#00A8B0"></path>
                                                <path d="M341.525952,207 C320.790657,207 304,224.029046 304,245 C304,265.944675 320.790657,283 341.525952,283 C362.209343,283 379,265.944675 379,245 C379,224.029046 362.209343,207 341.525952,207" id="Fill-5" fill="#00A8B0"></path>
                                                <path d="M293,152 C283.583558,152 276,159.601347 276,169.011448 C276,178.375758 283.583558,186 293,186 C302.37062,186 310,178.375758 310,169.011448 C310,159.601347 302.37062,152 293,152" id="Fill-7" fill="#00A8B0"></path>
                                                <path d="M413.537646,268 C386.708926,268 365,289.75912 365,316.487451 C365,343.291074 386.708926,365 413.537646,365 C440.316171,365 462,343.291074 462,316.487451 C462,289.75912 440.316171,268 413.537646,268" id="Fill-9" fill="#00A8B0"></path>
                                                <path d="M72.03946,34 C51.046729,34 34,50.9941156 34,71.9868467 C34,93.0058844 51.046729,110 72.03946,110 C93.0321911,110 110,93.0058844 110,71.9868467 C110,50.9941156 93.0321911,34 72.03946,34" id="Fill-11" fill="#00A8B0"></path>
                                                <path d="M293.02425,0 C260.456638,0 234,26.4027121 234,59.0363674 C234,91.5972879 260.456638,118 293.02425,118 C325.591862,118 352,91.5972879 352,59.0363674 C352,26.4027121 325.591862,0 293.02425,0" id="Fill-13" fill="#00A8B0"></path>
                                                <path d="M251,213 C241.606469,213 234,221.043069 234,231 C234,240.908479 241.606469,249 251,249 C260.393531,249 268,240.908479 268,231 C268,221.043069 260.393531,213 251,213" id="Fill-15" fill="#080200"></path>
                                                <path d="M169.011448,420 C159.601347,420 152,427.872054 152,437.558923 C152,447.175084 159.601347,455 169.011448,455 C178.352862,455 186,447.175084 186,437.558923 C186,427.872054 178.352862,420 169.011448,420" id="Fill-17" fill="#080200"></path>
                                                <path d="M71.9771198,373 C62.5962315,373 55,380.573351 55,390 C55,399.426649 62.5962315,407 71.9771198,407 C81.3580081,407 89,399.426649 89,390 C89,380.573351 81.3580081,373 71.9771198,373" id="Fill-19" fill="#080200"></path>
                                                <path d="M37.96054,213 C16.9941156,213 0,230 0,251 C0,272 16.9941156,289 37.96054,289 C58.953271,289 76,272 76,251 C76,230 58.953271,213 37.96054,213" id="Fill-21" fill="#080200"></path>
                                                <path d="M424.013153,118 C402.994116,118 386,135.014533 386,156.026298 C386,177.011765 402.994116,194 424.013153,194 C444.979578,194 462,177.011765 462,156.026298 C462,135.014533 444.979578,118 424.013153,118" id="Fill-23" fill="#080200"></path>
                                                <path d="M273.037447,304 C229.399589,304 194,339.374625 194,383.012482 C194,426.675304 229.399589,462 273.037447,462 C316.65034,462 352,426.675304 352,383.012482 C352,339.374625 316.65034,304 273.037447,304" id="Fill-25" fill="#080200"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                </div>`;
        this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';
    
        this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
          var $animate;
          var $parentSelector = this.parentSelector,
            loadingBarContainer = angular.element(this.loadingBarTemplate),
            loadingBar = loadingBarContainer.find('div').eq(0),
            spinner = angular.element(this.spinnerTemplate);
    
          var incTimeout,
            completeTimeout,
            started = false,
            status = 0;
    
          var autoIncrement = this.autoIncrement;
          var includeSpinner = this.includeSpinner;
          var includeBar = this.includeBar;
          var startSize = this.startSize;
    
          /**
           * Inserts the loading bar element into the dom, and sets it to 2%
           */
          function _start() {
            if (!$animate) {
              $animate = $injector.get('$animate');
            }
    
            $timeout.cancel(completeTimeout);
    
            // do not continually broadcast the started event:
            if (started) {
              return;
            }
    
            var document = $document[0];
            var parent = document.querySelector ?
              document.querySelector($parentSelector)
              : $document.find($parentSelector)[0]
            ;
    
            if (! parent) {
              parent = document.getElementsByTagName('body')[0];
            }
    
            var $parent = angular.element(parent);
            var $after = parent.lastChild && angular.element(parent.lastChild);
    
            $rootScope.$broadcast('cfpLoadingBar:started');
            started = true;
    
            if (includeBar) {
              $animate.enter(loadingBarContainer, $parent, $after);
            }
    
            if (includeSpinner) {
              $animate.enter(spinner, $parent, loadingBarContainer);
            }
    
            _set(startSize);
          }
    
          /**
           * Set the loading bar's width to a certain percent.
           *
           * @param n any value between 0 and 1
           */
          function _set(n) {
            if (!started) {
              return;
            }
            var pct = (n * 100) + '%';
            loadingBar.css('width', pct);
            status = n;
    
            // increment loadingbar to give the illusion that there is always
            // progress but make sure to cancel the previous timeouts so we don't
            // have multiple incs running at the same time.
            if (autoIncrement) {
              $timeout.cancel(incTimeout);
              incTimeout = $timeout(function() {
                _inc();
              }, 250);
            }
          }
    
          /**
           * Increments the loading bar by a random amount
           * but slows down as it progresses
           */
          function _inc() {
            if (_status() >= 1) {
              return;
            }
    
            var rnd = 0;
    
            // TODO: do this mathmatically instead of through conditions
    
            var stat = _status();
            if (stat >= 0 && stat < 0.25) {
              // Start out between 3 - 6% increments
              rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
            } else if (stat >= 0.25 && stat < 0.65) {
              // increment between 0 - 3%
              rnd = (Math.random() * 3) / 100;
            } else if (stat >= 0.65 && stat < 0.9) {
              // increment between 0 - 2%
              rnd = (Math.random() * 2) / 100;
            } else if (stat >= 0.9 && stat < 0.99) {
              // finally, increment it .5 %
              rnd = 0.005;
            } else {
              // after 99%, don't increment:
              rnd = 0;
            }
    
            var pct = _status() + rnd;
            _set(pct);
          }
    
          function _status() {
            return status;
          }
    
          function _completeAnimation() {
            status = 0;
            started = false;
          }
    
          function _complete() {
            if (!$animate) {
              $animate = $injector.get('$animate');
            }
    
            _set(1);
            $timeout.cancel(completeTimeout);
    
            // Attempt to aggregate any start/complete calls within 500ms:
            completeTimeout = $timeout(function() {
              var promise = $animate.leave(loadingBarContainer, _completeAnimation);
              if (promise && promise.then) {
                promise.then(_completeAnimation);
              }
              $animate.leave(spinner);
              $rootScope.$broadcast('cfpLoadingBar:completed');
            }, 500);
          }
    
          return {
            start            : _start,
            set              : _set,
            status           : _status,
            inc              : _inc,
            complete         : _complete,
            autoIncrement    : this.autoIncrement,
            includeSpinner   : this.includeSpinner,
            latencyThreshold : this.latencyThreshold,
            parentSelector   : this.parentSelector,
            startSize        : this.startSize
          };
    
    
        }];     //
      });       // wtf javascript. srsly
    })();       //